import * as Bootstrap from "bootstrap"

export function isInIframe() {
  return window.self !== window.top;
}

export function inputFillWith(inputId, text) {
  const textInput = document.getElementById(inputId);
  textInput.value = text;
  // We need to dispatch an input event for the submit button
  // to properly update it's state
  textInput.dispatchEvent(new Event('input', { bubbles: true }));
  textInput.focus();
}

export function inputSubmitWith(inputId, text) {
  const textInput = document.getElementById(inputId);
  textInput.value = text;
  textInput.closest("form").requestSubmit();
}

export function enableTooltips() {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Bootstrap.Tooltip(tooltipTriggerEl))
}

export function isValidHttpUrl(string) {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
}